import React, { memo } from 'react';
import { Dropdown, Menu, Row } from 'antd';
import styled, { ITheme } from 'styled-components';
import useActiveNetwork from 'src/hooks/useActiveNetwork';
import useActiveWallet from 'src/hooks/useActiveWallet';
import withConnect from 'src/hoc/withConnect';
import { ArrowIcon } from 'src/components/Icons';
import { useDispatch } from 'react-redux';
import useActiveWeb3React from 'src/hooks/useActiveWeb3React';
import { ChainId } from 'src/configs/Connect/Configs.chainId';
import { SUPPORTED_NETWORKS } from 'src/configs/Connect/Configs.networks';
import withWalletModal from 'src/components/WalletModal/WalletModal.enhence';

const Button = styled.button`
    width: fit-content !important;
    height: fit-content !important;
    padding: 12px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    display: flex;
    flex-direction: row;
    align-items: center;
    :disabled {
        opacity: 0.5;
        &:hover {
            cursor: pointer;
            transform: scale(1);
        }
    }
    .logo {
        margin-left: 16px;
        width: 24px;
        height: 24px;
        justify-content: center;
    }
    .icon-arrow {
        margin-left: 10px;
        color: #ffffff;
    }
`;

interface IBTNProps {
    className?: string;
    onClick?: () => void;
    item?: any;
}

const BTNNetwork = (props: IBTNProps & React.ButtonHTMLAttributes<HTMLButtonElement>) => {
    const { className, onClick, item, ...rest } = props;

    return (
        <Button className={`btn-primary ${className}`} onClick={onClick} {...rest}>
            {item.chainName}
            <ArrowIcon className="icon-arrow" />
        </Button>
    );
};

const MenuContainer = styled(Menu)`
    background: #000000;
    border: 1px solid #3c3c3c;
    .logo {
        margin-right: 16px;
        width: 24px;
        height: 24px;
        justify-content: center;
    }
    .item-network {
        // background: red;
        // border-bottom: 1px solid ${({ theme }) => theme.dark3};
    }
    .item-solana {
        margin-top: -5px;
        .custom-solana-dropdown {
            background: none;
            border: 0;
            height: 30px;
            align-items: center;
            font-size: 12px;
            display: flex;
            align-items: center;
            margin: 0;
            padding: 5px 12px;
            .wallet-adapter-icon {
                margin-right: 15px;
                margin-left: -12px;
            }
            p {
                font-weight: normal;
                font-size: 14px;
                line-height: 22px;
                white-space: nowrap;
                cursor: pointer;
                color: rgba(255, 255, 255, 0.65);
                &:hover {
                    color: white;
                }
            }
            svg {
                margin-right: 15px;
                margin-left: -12px;
                width: 24px;
                height: 24px;
            }
        }
    }
`;
const supportNetworks = [
    // SUPPORTED_NETWORKS[ChainId.MAINNET],
    // SUPPORTED_NETWORKS[ChainId.BSC_TESTNET],
    SUPPORTED_NETWORKS[ChainId.TC],
];

const DropdownNetwork = ({ openConnectWalletModal, changeChainId }: any) => {
    const { deactivate } = useActiveWeb3React();
    const activeNetwork = useActiveNetwork();
    const activeWallet = useActiveWallet();
    const dispatch = useDispatch();

    const onChooseNetwork = (item: any) => {
        changeChainId(item.chainNumb);
    };
    const menus = () => (
        <MenuContainer theme="dark" mode="horizontal">
            {supportNetworks.map((item: any) => {
                return (
                    <Menu.Item className="item-network" key={item.chainId} onClick={() => onChooseNetwork(item)}>
                        <Row>
                            <img
                                className="logo"
                                alt=""
                                src={require(`../../../assets/svg/network-logos${item.path}`)}
                            />
                            <p>{item.chainName}</p>
                        </Row>
                    </Menu.Item>
                );
            })}
        </MenuContainer>
    );

    if (!activeNetwork || !activeWallet || !activeWallet.supportNetworks) return null;

    return (
        <Dropdown overlay={menus} placement="bottomRight">
            <BTNNetwork item={activeNetwork} />
        </Dropdown>
    );
};

export default withWalletModal(withConnect(memo(DropdownNetwork)));
